import { createFeature, createReducer, on } from "@ngrx/store";
import { ExamStoreInterface } from "src/app/shared/interfaces";
import { examActions } from "./exam.action";

const initailState: ExamStoreInterface = {
    exams: [],
};

const examFeature = createFeature({
    name: "exam",
    reducer: createReducer(
        initailState,
        on(examActions.setExams, (state, action) => ({
            ...state,
            exams: action.data,
        })),
        on(examActions.create, (state) => ({ ...state })),
        on(examActions.update, (state) => ({ ...state })),
    ),
});

export const { name: examFeatureKey, reducer: examReducer, selectExams } = examFeature;
